// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import { themeCssVar as globalTheme } from '../../utils/theme';
import { PresetButtonColors } from '../Button';
import { BannerColorScheme } from './types';

export const Default: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.backgroundBannerDefault,
    backgroundIconContainer: globalTheme.gradient.brandGradient,
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.Neutral,
};

export const Brand: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.red05, // @TODO: replace with semantic token
    backgroundIconContainer: globalTheme.gradient.brandGradient,
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.PrimaryAccessible,
};

export const Gold: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.gold05, // @TODO: replace with semantic token
    backgroundIconContainer: globalTheme.gradient.backgroundGold,
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.PrimaryGold,
};

export const Platinum: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.backgroundBannerDefault,
    backgroundIconContainer: globalTheme.gradient.revenuePlatinum, // @TODO: replace with semantic gradient
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.PrimaryPlatinum,
};

export const Boost: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.backgroundPurple,
    backgroundIconContainer: globalTheme.gradient.backgroundBoost,
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.PrimaryBoost,
};

export const Trust: BannerColorScheme = {
  bannerColors: {
    backgroundContainer: globalTheme.color.backgroundTrust,
    backgroundIconContainer: globalTheme.color.iconTrust,
    foregroundHeadline: globalTheme.color.textBannerHeading,
    foregroundBody: globalTheme.color.textBannerBody,
  },
  buttonColors: PresetButtonColors.Neutral,
};
